import unidecode from 'unidecode';

export const toAsciiPrintable = (s: string): string => {
    return unidecode(s).replace(/[^ -~]/g, '');
}
